import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

const SettingsContext = createContext();

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};

export const SettingsProvider = ({ children }) => {
    const { user } = useAuth();
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);

    const fetchSettings = useCallback(async () => {
        if (!user || !user.companyId) {
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(`/api/settings/${user.companyId}`);
            if (response.ok) {
                const settingsMap = await response.json();
                setSettings(settingsMap);
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
        } finally {
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    const getSetting = (key, defaultValue = null) => {
        return settings[key] !== undefined ? settings[key] : defaultValue;
    };

    return (
        <SettingsContext.Provider value={{ settings, getSetting, loading, refreshSettings: fetchSettings }}>
            {children}
        </SettingsContext.Provider>
    );
};
